import { Grid, Card, CardActionArea, CardContent, Avatar, Box, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import './AnnualAppraisal.css';
import WorkIcon from '@mui/icons-material/Work';
import RateReviewIcon from '@mui/icons-material/RateReview';
import FeedIcon from '@mui/icons-material/Feed';
import { axiosFetch } from "../../../../utils/AxiosFetch";
import Filter from "./Filter";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { useDispatch } from "react-redux";
import { CustomizedSnackbar } from "../../../../shared";
import TeamMembers from "./TeamMembers";
import Tab from "./Tab";
import { PeriodList } from '../../../../utils/PeriodList';


function AnnualAppraisal() {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [myForm, setMyForm] = useState([]);
    const [teamForms, setTeamForms] = useState([]);

    const [dateFilter, setDateFilter] = useState("");
    const [keyword, setKeyword] = useState("");
    const [teamId, setTeamId] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [year, setYear] = useState("");

    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    useEffect(() => {
       
        if (isUserLogged.isManager || isUserLogged.usertype === "HR") {
            
            loadTeamDetails(1);
            // loadTeamForms();
        }
        loadMyForms();
        getCurrentSessionDetails();
       
    }, [])

    const handleChangeKeyword = (val) => {
        console.log(val);
        setKeyword(val);
    };

    const handleChangeDateFilter = (val) => {
        setDateFilter(val);
    }

    const handleChangeTeamId = (id) => {
        console.log(id);
        setTeamId(id);
    };

    const handleChangeDepartmentId = (id) => {
        console.log(id);
        setDepartmentId(id);
    };

    const handleChangeYear = (id) => {
        console.log(id);
        setYear(id);
    }

    const handleForm = (id) => {
        navigate(`/annual-appraisal-form/${id}`)
    }

    const loadMyForms = () => {
        axiosFetch({
            method: "get",
            url: `/performance/appraisal/true`,
        })
            .then((res) => {
                if (res.status === 200) {
                    setMyForm(res.data)
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err =>
                console.error(err)
            )
    }
    const loadTeamDetails = (val) => {
        var params;
         if( val === 1){
            const currentYear = new Date().getFullYear();
            var list = PeriodList(3, "half", true);
            const res = list.filter(list => parseInt(list.value) === parseInt(currentYear))[0];
            setYear(res.value);
            params  = {
                "keyword": null,
                "teamId": null,
                "departmentId": null,
                "year": res.value,
                // "dateFilter": null
            }
        }
        else {
            params = {
                "Keyword": keyword !== "" ? keyword : null,
                "TeamId": teamId !== "" ? teamId : null,
                "DepartmentId": departmentId !== "" ? departmentId : null,
                "Year": year !== "" ? year : null,
                // "dateFilter": dateFilter !== "" ? dateFilter : null
            }
        }

        axiosFetch({
            method: "post",
            url: `/performance/appraisal/team`,
            requestConfig: params
        })
            .then((res) => {
                if (res.status === 200) {
                    setTeamForms(res.data);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    // const loadTeamForms = (val) => {
    //     var params;
    //     if (val === 1) {
    //         params = {
    //             "keyword": null,
    //             "teamId": null,
    //             "departmentId": null,
    //             "year": null,
    //             "dateFilter": null
    //         }
    //     }
    //     else {
    //         params = {
    //             "Keyword": keyword !== "" ? keyword : null,
    //             "TeamId": teamId !== "" ? teamId : null,
    //             "DepartmentId": departmentId !== "" ? departmentId : null,
    //             "Year": year !== "" ? year : null,
    //             "dateFilter": dateFilter !== "" ? dateFilter : null
    //         }
    //     }
    //     axiosFetch({
    //         method: "post",
    //         url: `/performance/appraisal/search`,
    //         requestConfig: params
    //     })

    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setTeamForms(res.data)
    //             }
    //             else if (res.status === 400) {
    //                 dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
    //             }
    //             else if (res.status === 401) {
    //                 navigate('/');
    //             }
    //         })
    //         .catch(err =>
    //             console.error(err)
    //         )
    // }
    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        var list = PeriodList(3, "half", true);
        const res = list.filter(list => parseInt(list.value) === parseInt(currentYear))[0];
        setYear(res.value);
    }


    return (
        <div>
            <Grid container>
               
                {/* <Grid item xs={9}> */}
                <div className="annual-apprasial-forms-bg">
                <h2>My Form(s)</h2>
                <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                    {myForm.length > 0 ?
                        myForm.map((form) => {
                            return (
                                <Grid item xs={3}>
                                    <Card className="teamperformance-box" sx={{ borderRadius: "10px !important" }}>
                                        <CardActionArea onClick={() => handleForm(form.formId)}>
                                            <CardContent>
                                                <div style={{ textAlign: "center", padding: '3px' }}>
                                                    {/* <p><WorkIcon fontSize="small" className='icon-form' sx={{color:'green'}}/>role at that time </p> */}
                                                    <p><CalendarMonthIcon fontSize="small" className='icon-form' sx={{ color: form.statusName === "Completed" ? 'green' : 'rgb(44, 44, 126)' }} />{form.period}</p>
                                                    {/* <p className="appraisal-desc"><CalendarMonthIcon fontSize="small" className='icon-form' sx={{ color: form.statusName === "Completed" ? 'green' : 'rgb(44, 44, 126)' }} /><span> {form.period}</span></p> */}
                                                    <p className="appraisal-desc"><FeedIcon fontSize="small" className='icon-form' sx={{ color: form.statusName === "Completed" ? 'green' : 'rgb(44, 44, 126)' }} /> {form.statusName === "Employee Review" ? "Employee Review" : form.statusName === "Manager Review" ? "Manager Review" : form.statusName === "Moved to HR" ? "Moved to HR" : form.statusName === "Re Assign" ? "Re Assigned" : form.statusName}</p>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>

                                    </Card>
                                </Grid>
                            )
                        }) :
                        <Grid xs={12} sx={{ margin: 1 }}>
                            <Alert severity='error'>No Review History</Alert>
                        </Grid>}
                </Grid>
                </div>
                {isUserLogged.isManager !== false  ?
                <Grid item xs={12}>
                    <h1 className="main-heading">Annual Appraisal</h1>
                </Grid>:''}
                {isUserLogged.isManager !== false  ?
                    <Grid item xs={12}>
                        <Filter
                            handleChangeDepartmentId={handleChangeDepartmentId}
                            handleChangeKeyword={handleChangeKeyword}
                            handleChangeTeamId={handleChangeTeamId}
                            handleChangeYear={handleChangeYear}
                            handleChangeDateFilter={handleChangeDateFilter}
                            loadTeamForm={loadTeamDetails}
                        />
                    </Grid> : ""}

                      {isUserLogged.isManager === true ? <Tab teamdata={teamForms} /> : ''}
                {/* {isUserLogged.isManager === true ? <h2>Team Form(s)</h2> : ""}
                <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                    {isUserLogged.isManager === true ?
                        <TeamMembers teamList={teamForms.team} /> : ''
                    }
                </Grid>
                {(isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR") ?
                    <h2>Pending Appraisal Review Form(s)</h2> : ""}
                <Grid container spacing={2}>
                    {(isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR") ?

                        <TeamMembers teamList={teamForms.employees} /> : <></>}
                </Grid> */}
            </Grid>
            <CustomizedSnackbar />
            {/* </Grid> */}


        </div>
    )
}

export default AnnualAppraisal;